import React from "react";
import "./Trusted_By_Travellers.css";
import Common_Title from "../../common_component/common_title/Common_Title";

const Trusted_By_Travelers = () => {
  return (
    <section className="trusted-section">
      <div className="container">

        {/* Heading */}
        <h3 className="trusted-title">
         <Common_Title title="Trusted By Travelers WorldWide" />
        </h3>

        {/* Stats Row */}
        <div className="row g-3 stats-row">

          <div className="col-lg-3 col-md-6 col-sm-6 col-6">
            <div className="stat-box">
              <h4>10,000+</h4>
              <p>Happy Travelers</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-6 col-6">
            <div className="stat-box">
              <h4>1400+</h4>
              <p>Successful Tours Organized</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-6 col-6">
            <div className="stat-box">
              <h4>50+</h4>
              <p>Top Destinations Covered</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-6 col-6">
            <div className="stat-box">
              <h4>8+</h4>
              <p>Years of Travel Experience</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Trusted_By_Travelers;